import CostOverview from "../../../../components/CostOverview";

import OrderSimulationTable from "../../../../components/OrderSimulationTable";
import { TotalExpenses } from "../../../../components/TotalExpenses";

import TrashIcon from "../../../../assets/trashIcon.png";
import EditTableIcon from "../../../../assets/editTable.png";
import ImportFiles from "../../../../components/ImportFiles";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import api from "../../../../services/api";
import OrderLoadDisplay from "../../../../components/OrderLoadDisplay";
import DetailsOrderLoad from "../../../../components/DetailsOrderLoad";
import TaxesFromOrderLoad from "../../../../components/TaxesFromOrderLoad";
import { downloadFile, uploadFile } from "../../../../axios/uploadFiles";

import ConfirmOrCancelDelivery from "../../../../components/ConfirmDelivery";
import ConfirmationModal from "../../../../components/ConfirmationModal";
import OrderLoadPendingIssues from "../Pendencias";
import { useAuth } from "../../../../contexts/AuthContext";
import { DollarContext } from "../../../../contexts/DollarContext";

import useAttachmentsStore from "../../../../store/attachmentsStore";
import { v4 as uuidv4 } from "uuid";

const DetalhesCargas = () => {
  const { id, index } = useParams();
  const [orderLoadItems, setOrderLoadItems] = useState();
  const [orderLoad, setOrderLoad] = useState();
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [googleId1, setGoogleId1] = useState("");
  const [googleId2, setGoogleId2] = useState("");
  const [googleId3, setGoogleId3] = useState("");
  const [googleId4, setGoogleId4] = useState("");
  const [isLoadingEntrega, setIsLoadingEntrega] = useState(false);
  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [msgType, setMsgType] = useState("");
  const { user } = useAuth();
  const dollarPriceToday = useContext(DollarContext);
  const dollarInFloat = parseFloat(
    dollarPriceToday?.replace("R$", "")?.replace(",", ".")
  );
  const [isUploadFirstInputDone, setIsUploadFirstInputDone] = useState(false);
  const [isUploadSecondInputDone, setIsUploadSecondInputDone] = useState(false);
  const [isLoadingPdfUploadFirst, setIsLoadingPdfUploadFirst] = useState(false);
  const [isLoadingPdfUploadSecond, setIsLoadingPdfUploadSecond] =
    useState(false);
  const { addAttachment, attachments, clearAttachments } =
    useAttachmentsStore();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrderLoadItems = async () => {
      try {
        const response = await api.get(`/order-load-items/order/id/${id}`);

        setOrderLoadItems(response.data);
      } catch (error) {
        console.error("Error fetching order load:", error);
      }
    };

    fetchOrderLoadItems();
  }, [id]);

  useEffect(() => {
    const fetchOrderLoad = async () => {
      try {
        const response = await api.get(`/order-load/id/${id}`);
        setOrderLoad(response.data);
      } catch (error) {
        console.error("Error fetching order load:", error);
      }
    };

    fetchOrderLoad();
  }, [id]);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await api.get(`/attachments/${id}`);
        setAttachmentsData(response.data);
      } catch (error) {
        console.error("Erro ao obter pedido: ", error);
      }
    };
    fetchOrder();
  }, [id]);
  const onHandleDownload = async (fileId, fileName) => {
    try {
      const response = await downloadFile(fileId, fileName);
    } catch (error) {
      console.error("Erro ao baixar o arquivo:", error);
      alert(
        "Erro ao baixar o arquivo. Verifique sua conexão e tente novamente."
      );
    }
  };
  useEffect(() => {
    if (!Array.isArray(attachmentsData) || !attachmentsData.length) {
      return;
    }

    const attachmentsFilter = attachmentsData.filter(
      (item) => item.reference_type === "LOAD"
    );

    for (const attachment of attachmentsFilter) {
      console.log("attachment: ", attachment);
      if (
        attachment.attachment_description === "first" &&
        attachment.hasOwnProperty("google_id")
      ) {
        setGoogleId1(attachment.google_id);
      }
      if (
        attachment.attachment_description === "second" &&
        attachment.hasOwnProperty("google_id")
      ) {
        setGoogleId2(attachment.google_id);
      }
      if (
        attachment.attachment_description === "BILL OF LADDER" &&
        attachment.hasOwnProperty("google_id")
      ) {
        setGoogleId3(attachment.google_id);
      }
      if (
        attachment.attachment_description === "DECLARACAO DE IMPORTACAO" &&
        attachment.hasOwnProperty("google_id")
      ) {
        setGoogleId4(attachment.google_id);
      }
    }
  }, [attachmentsData]);

  if (!orderLoadItems) {
    return (
      <div>
        <h1>Carregando...</h1>
      </div>
    );
  }

  if (!orderLoad) {
    return (
      <div>
        <h1>Carregando...</h1>
      </div>
    );
  }

  const cofinsTotalValue = orderLoad.cofins;
  const icmsTotalValue = orderLoad.icms;
  const iiTotalValue = orderLoad.ii;
  const ipiTotalValue = orderLoad.ipi;
  const pisTotalValue = orderLoad.pis;
  const cmvReduce = orderLoad.total_unit;

  const totalPrevisto =
    (cofinsTotalValue +
      iiTotalValue +
      ipiTotalValue +
      pisTotalValue +
      icmsTotalValue +
      orderLoad.afrmm_tax_value +
      orderLoad.other_shipping_expenses_value +
      orderLoad.storage_value +
      orderLoad.customs_clearance_value +
      orderLoad.other_expenses +
      orderLoad.freight_collect_value) *
    dollarInFloat;

  const totalRealizado =
    (orderLoad.cofins_realized ?? 0) +
    (orderLoad.ii_realized ?? 0) +
    (orderLoad.ipi_realized ?? 0) +
    (orderLoad.pis_realized ?? 0) +
    (orderLoad.icms_realized ?? 0) +
    (orderLoad.afrmm_realized ?? 0) +
    (orderLoad.other_shipping_expenses_realized ?? 0) +
    (orderLoad.storage_realized ?? 0) +
    (orderLoad.customs_clearance_realized ?? 0) +
    (orderLoad.other_expenses_realized ?? 0) +
    (orderLoad.freight_collect_realized ?? 0);

  const impostosValorTotal = orderLoad.total_tax_value;

  const itemsSize =
    orderLoadItems.reduce((total, item) => {
      return total + item.size;
    }, 0) / 100;

  const transportesValorTotal =
    orderLoad.maritime_freight_value +
    orderLoad.land_freight_value / dollarInFloat; //frete terrestre está em real

  const custosValorTotal = orderLoadItems.reduce((total, item) => {
    return total + item.unit_value * item.quantity;
  }, 0);

  const diferenca = totalRealizado - totalPrevisto;

  const handleFileDeletion = async (googleId) => {
    try {
      const attachment = attachmentsData.find(
        (attach) => attach.google_id === googleId
      );

      if (!attachment) return;
      await api.delete(`/attachments/${attachment.id}`);

      window.location.reload();
    } catch (error) {
      console.log("Erro ao excluir o arquivo:", error);
    }
  };

  const handleOrderDelivered = async () => {
    setIsLoadingEntrega(true);
    try {
      await api.patch(`/orders/confirm-delivery/${id}`);
      setMessage("Entrega confirmada com sucesso!");
      setMsgType("success");

      setOrderLoad((prevState) => ({ ...prevState, isDelivered: true }));
    } catch (error) {
      console.error("Erro ao confirmar entrega do pedido: ", error);
      setMessage("Não foi possível confirmar a entrega");
      setMsgType("error");
    } finally {
      setIsLoadingEntrega(false);
    }
  };

  const handleCancelOrderDelivery = async () => {
    setIsLoadingEntrega(true);
    try {
      await api.patch(`/orders/cancel-delivery-confirmation/${id}`);
      setMessage("Confirmação de entrega cancelada com sucesso!");
      setMsgType("success");

      setOrderLoad((prevState) => ({ ...prevState, isDelivered: false }));
    } catch (error) {
      console.error(
        "Erro ao cancelar confirmação de entrega do pedido: ",
        error
      );
      setMessage("Não foi possível cancelar a confirmação de entrega");
      setMsgType("error");
    } finally {
      setIsLoadingEntrega(false);
    }
  };

  const navigateToEditOrderLoad = (id) => {
    navigate(`/cargas/edit/${id}`);
  };

  const handleDeleteOrderLoad = async (id) => {
    try {
      await api.delete(`/order-loads/${id}`);
      setIsModalOpen(false);
      navigate("/cargas");
    } catch (error) {
      setErrorMessage("Não foi possível excluir a carga");
      console.error("Erro ao excluir carga: ", error);
    }
  };

  const handleFileUpload = async (e, inputNumber, description) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        alert("Por favor, selecione um arquivo PDF.");
        return;
      }

      const MAX_FILE_SIZE = 5 * 1024 * 1024;
      if (file.size > MAX_FILE_SIZE) {
        alert("O arquivo excede o tamanho máximo permitido de 5MB.");
        return;
      }

      const tempReferenceId = uuidv4();

      if (inputNumber === 1) {
        setIsLoadingPdfUploadFirst(true);
      } else {
        setIsLoadingPdfUploadSecond(true);
      }

      try {
        const response = await uploadFile(file);

        console.log("name: ", response.result.name);

        const dbAttachmentsPost = {
          google_id: response.result.id,
          reference_id: tempReferenceId,
          reference_type: "TEMP",
          attachment_type: "ORDER_ATTACHMENT",
          attachment_description: description || response.result.name,
          privacy: "PUBLIC",
        };
        await api.post(`/attachments/create-attachment`, dbAttachmentsPost);

        addAttachment(dbAttachmentsPost.reference_id);

        const currentAttachments = useAttachmentsStore.getState().attachments;
        console.log("currentAttachments: ", currentAttachments);
        await api.put("/attachments/update-reference", {
          temp_reference_ids: currentAttachments,
          order_id: id,
          reference_type: "LOAD",
        });

        alert("PDF enviado com sucesso!");

        if (inputNumber === 1) {
          setIsUploadFirstInputDone(true);
        } else {
          setIsUploadSecondInputDone(true);
        }

        window.location.reload();
      } catch (error) {
        console.error("Erro ao enviar o arquivo:", error);
        alert(
          "Erro ao enviar o arquivo. Habilite o pop-up no seu navegador, ou sua conexão com a internet."
        );
      } finally {
        setIsLoadingPdfUploadFirst(false);
        setIsLoadingPdfUploadSecond(false);
      }
    }
  };

  return (
    <div>
      {isModalOpen && (
        <ConfirmationModal
          onClose={() => setIsModalOpen(false)}
          onConfirm={() => handleDeleteOrderLoad(orderLoad.id)}
          errorMessage={errorMessage}
        />
      )}
      <div className="flex items-center gap-4 p-4">
        {/* Fornecedor */}
        <div className="flex items-center gap-2">
          <div className="flex flex-col gap-4">
            <div>
              <span className="font-bold text-gray-600">FORNECEDOR</span>
              <span className="px-2 py-1 bg-gray-200 font-semibold text-gray-700 rounded-md">
                {orderLoad.supplier_name}
              </span>
              <span className="text-gray-500">
                Chegada em{" "}
                <span className="font-bold text-gray-600">
                  {new Date(orderLoad.loading_date).toLocaleDateString("pt-BR")}
                </span>
              </span>
            </div>
            <div>
              <span className="font-bold text-gray-600">AGENTE: </span>
              <span className="px-2 py-1 bg-gray-200 font-semibold text-gray-700 rounded-md capitalize">
                {orderLoad?.agent?.name}
              </span>
            </div>
          </div>
        </div>

        {/* Statuses */}
        <div className="flex items-center gap-2 ml-auto">
          <div className=" bg-gray-300 text-white flex items-center justify-center  px-4 py-2 rounded-full text-base font-bold">
            PI
          </div>
          <div className=" bg-[#77E066] text-white flex items-center justify-center  px-4 py-2 rounded-full text-base font-bold">
            PL
          </div>
          <div className="bg-gray-300 text-white flex items-center justify-center  px-4 py-2 rounded-full text-base font-bold">
            BL
          </div>
          <div className="bg-gray-300 text-white flex items-center justify-center  px-4 py-2 rounded-full text-base font-bold">
            DI
          </div>
          <div className="bg-gray-300 text-white flex items-center justify-center  px-4 py-2 rounded-full text-base font-bold">
            NM
          </div>
          <div className=" bg-[#77E066] text-white flex items-center justify-center  px-4 py-2 rounded-full text-base font-bold">
            CF
          </div>
        </div>

        {user && user.accessType !== "AGENT" && (
          <div className="flex w-[100px] justify-between items-center">
            <button
              type="button"
              onClick={() => navigateToEditOrderLoad(orderLoad.id)}
            >
              <img
                src={EditTableIcon}
                alt="ícone para editar tabela"
                className="w-[32px] h-[32px]"
              />
            </button>

            <button
              type="button"
              onClick={() => {
                setIsModalOpen(true);
                setErrorMessage("");
              }}
            >
              <img
                src={TrashIcon}
                alt="ícone para excluir"
                className="w-[27px] h-[32px]"
              />
            </button>
          </div>
        )}
      </div>
      <OrderLoadDisplay orderItems={orderLoadItems} />
      <DetailsOrderLoad
        id={orderLoad.id}
        index={index}
        title={"Detalhes do pedido"}
        impostos={impostosValorTotal}
        transporte={transportesValorTotal}
        custo={custosValorTotal}
        total={impostosValorTotal + transportesValorTotal + custosValorTotal}
      />
      {user && user.accessType !== "AGENT" && (
        <ConfirmOrCancelDelivery
          handle={
            orderLoad.isDelivered
              ? handleCancelOrderDelivery
              : handleOrderDelivered
          }
          message={message}
          msgType={msgType}
          isLoadingEntrega={isLoadingEntrega}
          isOrderLoadDelivered={orderLoad.isDelivered}
        />
      )}

      <ImportFiles
        onDownloadFileCardBill={() =>
          onHandleDownload(googleId3, "Bill-Of-Ladder.pdf")
        }
        onDownloadFileCardImport={() =>
          onHandleDownload(googleId4, "Declaracao-Importacao.pdf")
        }
        onDownload={() =>
          onHandleDownload(googleId1, "Proforma-invoice-alvo.pdf")
        }
        onDownload2={() =>
          onHandleDownload(googleId2, "Proforma-invoice-alvo.pdf")
        }
        ids={{ googleId1, googleId2, googleId3, googleId4 }}
        isDownloadOneEnabled={orderLoad.isDownloadOneEnabled}
        isDownloadTwoEnabled={orderLoad.isDownloadTwoEnabled}
        isDownloadThreeEnabled={orderLoad.isDownloadThreeEnabled}
        isDownloadFourEnabled={orderLoad.isDownloadFourEnabled}
        onUpload={handleFileUpload}
        identifier
        onDelete={handleFileDeletion}
      />
      <TaxesFromOrderLoad
        cmvFromApi={cmvReduce}
        cofinsFromApi={cofinsTotalValue}
        icmsFromApi={icmsTotalValue}
        iiFromApi={iiTotalValue}
        ipipasepFromApi={ipiTotalValue}
        id={id}
        pis={pisTotalValue}
        afrmm={orderLoad.afrmm_tax_value}
        collectDeFrete={orderLoad.freight_collect_value}
        outrasDespesasFrete={orderLoad.other_shipping_expenses_value}
        storageTax={orderLoad.storage_value}
        otherExpenses={orderLoad.other_expenses}
        desembarqueAduaneiroFromApi={orderLoad.customs_clearance_value}
        dollarInFloat={dollarInFloat}
        afrmmTaxType={orderLoad.afrmm_tax_type}
        freightCollectTaxType={orderLoad.freight_collect_tax_type}
        otherShippingCostsTaxType={orderLoad.other_shipping_costs_tax_type}
        customsClearanceType={orderLoad.customs_clearance_type}
        otherExpensesType={orderLoad.other_expenses_type}
        storageTaxType={orderLoad.storage_tax_type}
      />

      <TotalExpenses
        order={`C00${index}-${new Date().getFullYear()}`}
        previsto={totalPrevisto}
        realizado={totalRealizado}
        diferenca={diferenca}
      />

      <OrderSimulationTable
        transporte={Number(
          orderLoad.maritime_freight_value * dollarInFloat +
            (orderLoad.freight_collect_realized ??
              orderLoad.freight_collect_value * dollarInFloat) +
            (orderLoad.other_shipping_expenses_realized ??
              orderLoad.other_shipping_expenses_value * dollarInFloat) +
            orderLoad.land_freight_value
        )}
        outrosCustos={Number(
          (orderLoad.afrmm_realized ??
            orderLoad.afrmm_tax_value * dollarInFloat) +
            (orderLoad.storage_realized ??
              orderLoad.storage_value * dollarInFloat) +
            (orderLoad.other_expenses_realized ??
              orderLoad.other_expenses * dollarInFloat) +
            (orderLoad.customs_clearance_realized ??
              orderLoad.customs_clearance_value * dollarInFloat) +
            orderLoad.another_tax_value * dollarInFloat
        )}
        dollarInFloat={dollarInFloat}
      />

      <CostOverview
        title="Custos Unitários dos produtos"
        order={`C00${index}-${new Date().getFullYear()}`}
        valuePrevisto={totalPrevisto}
        valueRealizado={totalRealizado}
        diferenca={diferenca}
      />

      <OrderLoadPendingIssues />
    </div>
  );
};

export default DetalhesCargas;
